import pimg1 from '../images/gallery/student.webp'
import pimg2 from '../images/gallery/univ.webp'
import pimg3 from '../images/gallery/international.webp'
import pimg4 from '../images/gallery/seminar.webp'
import pimg5 from '../images/gallery/tedx.webp'
import pimg6 from '../images/gallery/award.webp'

import ps1img1 from '../images/gallery/student.webp'
import ps1img2 from '../images/gallery/univ.webp'
import ps1img3 from '../images/gallery/international.webp'
import ps1img4 from '../images/gallery/seminar.webp'
import ps1img5 from '../images/gallery/tedx.webp'
import ps1img6 from '../images/gallery/award.webp'

import psub1img1 from '../images/gallery/seminar.webp'
import psub1img2 from '../images/gallery/tedx.webp'


const Projects = [
    {
       Id:'1',
       pImg:pimg1,
       ps1img:ps1img1,
       psub1img1:psub1img1,
       psub1img2:psub1img2,
       title:'Student Success Stories',
       subTitle:'Students',
    },
    {
       Id:'2',
       pImg:pimg2,
       ps1img:ps1img2,
       psub1img1:psub1img1,
       psub1img2:psub1img2,
       title:'University Delegations',
       subTitle:'University Partners',
    },
    {
      Id:'3',
      pImg:pimg3,
      ps1img:ps1img3,
      psub1img1:psub1img1,
      psub1img2:psub1img2,
      title:'International Conferences',
      subTitle:'Global Events',
   },
   {
      Id:'4',
      pImg:pimg4,
      ps1img:ps1img4,
      psub1img1:psub1img1,
      psub1img2:psub1img2,
      title:'School & College Seminars',
      subTitle:'Speaking',
   },
   {
      Id:'5',
      pImg:pimg5,
      ps1img:ps1img5,
      psub1img1:psub1img1,
      psub1img2:psub1img2,
      title:'TEDx & Media Appearances',
      subTitle:'Media',
   },
   {
      Id:'6',
      pImg:pimg6,
      ps1img:ps1img6,
      psub1img1:psub1img1,
      psub1img2:psub1img2,
      title:'Awards & Recognition',
      subTitle:'Recognition',
   },
]

export default Projects;